import React, { useState } from "react";
import FormCard from "./FormCard";
import { IoIosArrowUp } from "react-icons/io";
import { IoIosArrowDown } from "react-icons/io";

const accordionData = [
  {
    title: "1. Training - How to train a model",
    content: (
      <div>
        <p className=" text-[17px]">
          Learn how to Train a model using the barrier seal and dry gas seal
          tags, along with their respective assemblies, by selecting a time
          period that exhibits normal operational behavior in their values.
          <img
            src={"assets/Training1.png"}
            alt="Training"
            className="w-full h-auto"
          />
          <ol className="list-decimal ml-5 mt-2 leading-7">
            <li>
              Assemblies: set of various assemblies available. (*Mandatory
              field)
            </li>
            <li>
              Product Line and Product Family: Choose the Product Line , Product
              Family values are based on the selected Product Line
            </li>

            <li>
              Subsystem: Multiselect Dropdown to select subsystem based on
              assembly. Values are pre-filled based on selected assembly.{" "}
            </li>
            <li>
              Frequency: to select the frequency of the data points for training
              the model. Default is 30mins.
            </li>
            <li>
              Dry Gas Seal Tags: set of corresponding dry gas seal tags
              displayed after the selection of a particular assembly.
              (*Mandatory field)
              <ul className="list-disc ml-5 mt-1">
                <li>
                  This is a multiselect field where you may select multiple tags
                  in combination with one particular assembly.
                </li>
              </ul>
            </li>

            <li>
              DGS Info:
              <ul className="list-disc ml-5 mt-1">
                <li>DGS Make: to select the make of the dry gas seal.</li>
                <li>DGS Type: to select the type of dry gas seal.</li>
                <li>
                  DGS Direction: to select the direction of the dry gas seal.
                </li>
                <li>
                  M/C Max Operating Speed: to enter the maximum operating speed
                  of the machine.
                </li>
                <li>M/C Trip Speed: to enter the trip speed of the machine.</li>
                <li>
                  M/C Design Pressure: to enter the design pressure of the
                  machine.
                </li>
              </ul>
            </li>
            <li>
              Start date: to enter the start date for model training. The date
              range should be between 3 months (90 days) and 1 year (365 days)
              and max date can be upto yesterday date.
            </li>
            <li>
              End date: to enter the end date for model training. The date range
              should be between 3 months (90 days) and 1 year (365 days) and max
              date can be upto today date.
            </li>

            <li>
              Name and description: to represent an individual model. (Optional
              field)
            </li>
            <li>
              Business Rules: to set the business rules for the model.
              <ul className="list-disc ml-5 mt-1">
                <li>
                  User can expand and minimize business rule after clicking on a
                  business rule row.
                </li>
                <li>
                  User can select multiple business rules based on the selection
                  of DGS tags and apply alias tag conditions like greater, less,
                  equal, and not equal.
                </li>
                <li>
                  User can add, edit, delete, cancel, and clear all business
                  rules.
                </li>
                <br />
                <img
                  src={"assets/BR.png"}
                  alt="Business Rule"
                  className="w-full h-auto"
                />
                <br />
              </ul>
            </li>
            <li>
              Time series : Chart is displayed on multiple y-axis line chart
              after selecting single or multiple DGS tags and y-axis will keep
              adding when adding new tags in selection. User can zoom in and
              zoom out in timeseries chart
            </li>
            <img
              src={"assets/Timeserieschart.png"}
              alt="Business Rule"
              className="w-full h-auto"
            />

            <li>
              Existing Models: User can view the list of existing models with
              their Name, Assembly, Dry Gas Seal Tags, Status -
              Active/In-Active, Created Date, Start Date, End Date, and Training
              Status - Completed/Failed/In-Progress.
            </li>
            <br />
            <img
              src={"assets/exisitingmodels.png"}
              alt="Business Rule"
              className="w-full h-auto"
            />
          </ol>
        </p>
      </div>
    ),
  },
  {
    title: "2. Models - How to view and manage models",
    content: (
      <div>
        <p className=" text-[17px]">
          Learn how to view the list of pre-trained models along with their
          accuracy and training details to Activate or Deactivate as per the
          requirement.
          <img
            src={"assets/Models.png"}
            alt="Models"
            className="w-full h-auto"
          />
          <ol className="list-decimal ml-5 mt-2 leading-7">
            <li>
              Assemblies: set of various assemblies available. (*Mandatory
              field)
            </li>
            <li>
              Dry Gas Seal Tags: set of corresponding dry gas seal tags
              displayed after the selection of a particular assembly.
              (*Mandatory field)
              <ul className="list-disc ml-5 mt-1">
                <li>
                  This is a multiselect field where you may select multiple tags
                  in combination with one particular assembly.
                </li>
              </ul>
            </li>
            <li>
              Models Table : After selecting an active assembly and its
              corresponding active dgs tags, the list of already generated
              models is displayed with their active status and a link to their
              inference.
              <ul className="list-disc ml-5 mt-1">
                <li>
                  The inference link directs to the inference tab with prefill
                  details such as the selected assembly and dgs tags.
                </li>
                <li>
                  The list of already trained models displayed in the list
                  includes the Name, Assembly, Dry Gas Seal Tags, Status -
                  Active/ In-Active, Created Date, Start Date, End Date,
                  Training Status - Completed/ Failed/ In-Progress and Link to
                  inference tab.
                </li>
                <li>
                  The active status of models can be toggled on and off on this
                  page using a toggle button.
                </li>
                <li>
                  If a user wants to see all other information about a
                  particular model, they can click on that model row and view
                  all related information, including business rules, in a
                  tabular format.
                </li>
              </ul>
            </li>

            <img
              src={"assets/ModelsTable.png"}
              alt="ModelsTable"
              className="w-full h-auto"
            />
            <ul className="list-disc ml-5 mt-1">
              <li>
                The active status of models can be toggled on and off on this
                page using a toggle button.
              </li>
              <li>
                If a user wants to see all other information about a particular
                model, they can click on that model row and view all related
                information, including business rules, in a tabular format.
              </li>
            </ul>

            <img
              src={"assets/ModelsTableExpanded.png"}
              alt="ModelsTableExpanded"
              className="w-full h-auto"
            />
          </ol>
        </p>
      </div>
    ),
  },
  {
    title: "3. Inference - How to observe model inference",
    content: (
      <div>
        <p>
          Learn how to select a model to observe its generated inference
          comparison with the ground truth data in the selected time period.
          <img
            src={"assets/Inference.png"}
            alt="Inference"
            className="w-full h-auto"
          />
          <ol className="list-decimal ml-5 mt-2 leading-7">
            <li>
              Assemblies: set of various assemblies available. (*Mandatory
              field)
            </li>
            <li>
              Dry Gas Seal Tags: set of corresponding dry gas seal tags
              displayed after the selection of a particular assembly.
              (*Mandatory field)
              <ul className="list-disc ml-5 mt-1">
                <li>
                  The field where you may select combination of DGS tags with
                  selected assembly.
                </li>
              </ul>
            </li>
            <li>
              Tags: Single tags list from the combination of tags selected,
              displayed after the selection of a particular assembly and dgs
              tags
              <ul className="list-disc ml-5 mt-1">
                <li>
                  This is MultiSelect field where you may select multiple tags
                  from combination of selected DGS tag and selected assembly.
                </li>
              </ul>
            </li>

            <li>
              Start date: to enter the start date for model training. The date
              range should be between 3 months (90 days) and 1 year (365 days)
              and max date can be upto yesterday date.
            </li>
            <li>
              End date: to enter the end date for model training. The date range
              should be between 3 months (90 days) and 1 year (365 days) and max
              date can be upto today date.
            </li>
            <li>
              Inference Graph: The inference graph is displayed with the
              predicted value, ground truth value contains anomalies points
              marked in Red Color for particular tag.
            </li>

            <img
              src={"assets/inferencechart.png"}
              alt="Inference"
              className="w-full h-auto"
            />
            <li>
              Existing Models: User can view the list of existing models with
              their Name, Assembly, Dry Gas Seal Tags, Status -
              Active/In-Active, Created Date, Start Date, End Date, and Training
              Status - Completed/Failed/In-Progress.
            </li>
            <br />
            <img
              src={"assets/ExisitingModelsInference.png"}
              alt="Exisiting Models in"
              className="w-full h-auto"
            />
            <li>
              Anomalies Detected: The anomalies detected are displayed in the
              table below the inference graph that contains Tag , Timestamp,
              Value, and Anomaly Detected(only 1s).
            </li>
            <br />
            <img
              src={"/assets/Anaomalies.png"}
              alt="Anomalies Rule"
              className="w-full h-auto"
            />
          </ol>
        </p>
      </div>
    ),
  },
  {
    title: "4. Forecast - How to generate and review forecasts",
    content: (
      <div>
        <p className=" text-[17px]">
          Learn how to configure a forecast using the selected assembly and tag
          combination, apply business rules, and review forecast output with
          anomalies.
          <img
            src={"/assets/forecast-home.png"}
            alt="Forecast Home"
            className="w-full h-auto"
          />
          <ol className="list-decimal ml-5 mt-2 leading-7">
            <li>
              Assembly: select the assembly for which the forecast needs to be
              created. (*Mandatory field)
            </li>
            <li>
              Dry Gas Seal Tags: select the corresponding dry gas seal tag set
              for the chosen assembly. (*Mandatory field)
            </li>
            <li>
              Independent Tags: optionally select additional independent tags to
              include in the forecast flow.
            </li>
            <li>
              Training Start Date and Training End Date: define the historical
              time period used to prepare the forecast input data.
            </li>
            <li>
              Business Rules: expand this section to add alias-based conditions
              using operators and threshold values before applying them to the
              forecast timeseries.
              <ul className="list-disc ml-5 mt-1">
                <li>
                  User can add, edit, delete, and apply multiple business rules.
                </li>
                <li>
                  Applied business rules affect the training timeseries shown on
                  the screen.
                </li>
              </ul>
            </li>
            <img
              src={"/assets/BR_forecast.png"}
              alt="Business Rules Forecast"
              className="w-full h-auto"
            />
            <li>
              Forecast Selection: expand this section to choose the tag aliases
              to forecast and configure the future forecast window.
              <ul className="list-disc ml-5 mt-1">
                <li>
                  Tag Alias: multiselect field to choose one or more tags.
                </li>
                <li>
                  Future Start Date and Future End Date: define the future date
                  range for forecast generation.
                </li>
                <li>
                  Frequency: sets the interval in minutes for forecast points.
                </li>
                <li>
                  Name and Description: provide a forecast name and optional
                  description.
                </li>
              </ul>
            </li>
            <img
              src={"/assets/forecast-selection.png"}
              alt="Forecast Selection"
              className="w-full h-auto"
            />
            <li>
              Forecast button: starts forecast generation once the mandatory
              assembly and tag selections are available.
            </li>
            <li>
              Live Forecasts: after a forecast is started, the generated
              forecast models are listed below with their current status and
              actions to review or manage them.
            </li>
            <img
              src={"/assets/existing-forecast-models.png"}
              alt="Existing Forecasts Models"
              className="w-full h-auto"
            />
            <li>
              Timeseries Chart: displays the historical chart for the selected
              tags and applied business rules.
            </li>
            <img
              src={"/assets/tags_chart.png"}
              alt="Timeseries Chart"
              className="w-full h-auto"
            />
            <li>
              Forecast Chart: shown after selecting a forecast model, displaying
              the generated future forecast values for the chosen tag aliases.
            </li>
            <img
              src={"/assets/forecast-chart.png"}
              alt="Forecast Chart"
              className="w-full h-auto"
            />
            <li>
              Anomalies Detected: anomalies from the selected forecast are shown
              in the table below the forecast chart for detailed review.
            </li>
          </ol>
        </p>
      </div>
    ),
  },
];

const HowToForm = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const handleAccordionClick = (idx) => {
    setOpenIndex(openIndex === idx ? null : idx);
  };

  return (
    <div className="flex justify-center flex-col gap-10 items-center mt-4 mb-20">
      <FormCard>
        <div>
          <span className="font-semibold text-2xl text-btn-primary">
            How To
          </span>
          <p className="mt-3 text-[14.5px]">
            {" "}
            Learn how to use the application .
          </p>
        </div>

        <div className=" w-full">
          {accordionData.map((item, idx) => (
            <div key={item.title} className="border-b">
              <button
                className="w-full text-left py-3 text-lg text-btn-primary  font-semibold focus:outline-none flex justify-between items-center"
                onClick={() => handleAccordionClick(idx)}
                aria-expanded={openIndex === idx}
              >
                {item.title}
                <span>
                  {openIndex === idx ? <IoIosArrowUp /> : <IoIosArrowDown />}
                </span>
              </button>
              {openIndex === idx && (
                <div className="py-2 text-[14.5px] text-gray-700">
                  {item.content}
                </div>
              )}
            </div>
          ))}
        </div>
      </FormCard>
    </div>
  );
};

export default HowToForm;
